import React, { useState } from 'react';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Albums from './components/Albums';
import News from './components/News';
import Films from './components/Films';
import Story from './components/Story';
import Merch from './components/Merch';
import Contact from './components/Contact';
import './styles/App.css';

function App() {
  const [currentSection, setCurrentSection] = useState('home');

  const renderSection = () => {
    switch(currentSection) {
      case 'home': return <Home />;
      case 'albums': return <Albums />;
      case 'films': return <Films />;
      case 'story': return <Story />;
      case 'news': return <News />;
      case 'merch': return <Merch />;
      case 'contact': return <Contact />;
      default: return <Home />;
    }
  };

  return (
    <div className="App">
      <Navigation currentSection={currentSection} setCurrentSection={setCurrentSection} />
      <main style={{ paddingTop: currentSection === 'home' ? '0' : '64px' }}>
        {renderSection()}
      </main>
      {currentSection !== 'home' && (
        <footer style={styles.footer}>
          <p>© 2025 PANTERA MG. All rights reserved.</p>
          <p style={{ marginTop: '1rem', fontStyle: 'italic' }}>
            Bailar es felicidad / Dancing is happiness
          </p>
        </footer>
      )}
    </div>
  );
}

const styles = {
  footer: {
    background: '#000',
    borderTop: '1px solid #333',
    padding: '2rem',
    textAlign: 'center',
    color: '#666',
  },
};

export default App;